var ezdia;
(function (ezdia) {
    /**
     * This validator method use to validate email value in tag input type.
     */
    $.validator.addMethod('tagemail', function tagemail(value, element) {
        var _this = this;
        if (this.optional(element)) {
            return true;
        }
        var emails = value.split(',');
        var valid = true;
        emails.forEach(function (email) {
            var trimvalue = email.trim();
            valid =
                valid && $.validator.methods.email.call(_this, trimvalue, element);
        });
        return valid;
    }, 'Please enter valid email addresses.');
})(ezdia || (ezdia = {}));
